export const advantagesSections = [
  `<section class="bg-light pb-5 pt-5 text-center text-lg-start">
    <div class="container pb-4 pt-4 text-center">
        <p class="display-5 fw-bold">Unsere Vorteile</p>
        <div class="align-items-center justify-content-end row text-start">
            <div class="bg-primary col-lg-6 pb-3 pt-3 rounded-5">
                <div class="pb-3 pt-3">
                    <h3 class="fs-2 text-white">Schnelligkeit</h3>
                    <p class="fs-5 fw-light mb-0 text-white">Erstellen und versenden Sie Rechnungen in Sekunden &ndash; sparen Sie wertvolle Zeit und vermeiden Sie unnötigen Papierkram.</p>
                </div>
            </div>
        </div>
        <div class="align-items-center row text-start">
            <div class="bg-primary col-lg-6 order-lg-1 pb-3 pt-3 rounded-5">
                <div class="pb-3 pt-3">
                    <h3 class="fs-2 text-white">Übersichtlichkeit</h3>
                    <p class="fs-5 fw-light mb-0 text-white">Alle Rechnungen, Zahlungen und Kundeninformationen sind zentral gespeichert und jederzeit abrufbar.</p>
                </div>
            </div>
        </div>
        <div class="align-items-center justify-content-end row text-start">
            <div class="bg-primary col-lg-6 pb-3 pt-3 rounded-5">
                <div class="pb-3 pt-3">
                    <h3 class="fs-2 text-white">Automatisierung</h3>
                    <p class="fs-5 fw-light mb-0 text-white">Automatische Zahlungserinnerungen und Workflows reduzieren Verwaltungsaufwand und verbessern den Cashflow.</p>
                </div>
            </div>
        </div>
        <div class="align-items-center row text-start">
            <div class="bg-primary col-lg-6 pb-3 pt-3 rounded-5">
                <div class="pb-3 pt-3">
                    <h3 class="fs-2 text-white">Sicherheit</h3>
                    <p class="fs-5 fw-light mb-0 text-white">Ihre Daten sind DSGVO-konform geschützt und werden verschlüsselt gespeichert &ndash; für maximale Sicherheit.</p>
                </div>
            </div>
        </div>
    </div>
</section>`,
  // 1 — світла, три колонки з іконками
  `<section id="advantages1" class="bg-light py-5 text-center">
    <div class="container">
      <h2 class="h6 text-primary text-uppercase mb-2">Переваги</h2>
      <h3 class="fw-bold h2 mb-4">Чому обирають WhiteEx</h3>
      <div class="row justify-content-center">
        <div class="col-md-4 mb-4">
          <i class="bi bi-gear-fill text-primary display-5 mb-3"></i>
          <h5 class="fw-bold">Структуровані процеси</h5>
          <p class="text-secondary small">
            Усі бізнес-процеси в WhiteEx впорядковані та логічно пов’язані. Це зменшує ризики хаосу й дублювання дій.
          </p>
        </div>
        <div class="col-md-4 mb-4">
          <i class="bi bi-shield-check text-primary display-5 mb-3"></i>
          <h5 class="fw-bold">Безпечне зберігання даних</h5>
          <p class="text-secondary small">
            Ми забезпечуємо високий рівень захисту кожного користувача та його інформації, відповідно до стандартів Швейцарії.
          </p>
        </div>
        <div class="col-md-4 mb-4">
          <i class="bi bi-lightbulb text-primary display-5 mb-3"></i>
          <h5 class="fw-bold">Аналітика в реальному часі</h5>
          <p class="text-secondary small">
            Дані автоматично оновлюються, що дозволяє швидко приймати обґрунтовані рішення у будь-який момент.
          </p>
        </div>
      </div>
    </div>
  </section>`,

  // 2 — темна секція без іконок
  `<section id="advantages2" class="bg-dark text-white py-5">
    <div class="container">
      <div class="text-center mb-5">
        <h2 class="h6 text-warning text-uppercase mb-2">WhiteEx</h2>
        <h3 class="fw-bold h2 mb-3">Наші ключові сильні сторони</h3>
      </div>
      <div class="row gy-4">
        <div class="col-md-6">
          <h5 class="fw-bold">1. Методична чіткість</h5>
          <p class="small text-light opacity-75">
            Кожен елемент системи побудовано на логіці й точності — від інтерфейсу до процесів.
          </p>
        </div>
        <div class="col-md-6">
          <h5 class="fw-bold">2. Гнучка інтеграція</h5>
          <p class="small text-light opacity-75">
            WhiteEx легко адаптується під специфіку компанії — незалежно від розміру чи напрямку діяльності.
          </p>
        </div>
        <div class="col-md-6">
          <h5 class="fw-bold">3. Мінімум ручних дій</h5>
          <p class="small text-light opacity-75">
            Система автоматизує повторювані процеси, економлячи час і ресурси команди.
          </p>
        </div>
        <div class="col-md-6">
          <h5 class="fw-bold">4. Прозорість у всьому</h5>
          <p class="small text-light opacity-75">
            Кожна дія документується — це забезпечує контроль і довіру між усіма учасниками.
          </p>
        </div>
      </div>
    </div>
  </section>`,

  // 3 — біла секція з кольоровими картками та іконками
  `<section id="advantages3" class="bg-white py-5 text-center">
    <div class="container">
      <h2 class="h6 text-uppercase text-primary mb-2">Наші переваги</h2>
      <h3 class="fw-bold h2 mb-5">Технологічність у кожному рішенні</h3>
      <div class="row g-4">
        <div class="col-md-3">
          <div class="border rounded-3 p-4 h-100 shadow-sm">
            <i class="bi bi-speedometer2 text-primary display-6 mb-2"></i>
            <h5 class="fw-bold">Швидкість</h5>
            <p class="small text-secondary">Операції виконуються миттєво — без затримок чи надлишкових кроків.</p>
          </div>
        </div>
        <div class="col-md-3">
          <div class="border rounded-3 p-4 h-100 shadow-sm">
            <i class="bi bi-graph-up text-success display-6 mb-2"></i>
            <h5 class="fw-bold">Ефективність</h5>
            <p class="small text-secondary">WhiteEx оптимізує внутрішні процеси, підвищуючи продуктивність команди.</p>
          </div>
        </div>
        <div class="col-md-3">
          <div class="border rounded-3 p-4 h-100 shadow-sm">
            <i class="bi bi-people text-warning display-6 mb-2"></i>
            <h5 class="fw-bold">Командна робота</h5>
            <p class="small text-secondary">Зручна взаємодія між усіма відділами компанії в єдиній системі.</p>
          </div>
        </div>
        <div class="col-md-3">
          <div class="border rounded-3 p-4 h-100 shadow-sm">
            <i class="bi bi-shield-lock text-danger display-6 mb-2"></i>
            <h5 class="fw-bold">Захист</h5>
            <p class="small text-secondary">Дані зберігаються у зашифрованій формі, що гарантує конфіденційність.</p>
          </div>
        </div>
      </div>
    </div>
  </section>`,

  // 4 — асиметрична секція без іконок (з лівим акцентом)
  `<section id="advantages4" class="bg-light py-5">
    <div class="container">
      <div class="row align-items-center gy-4">
        <div class="col-lg-5">
          <h2 class="fw-bold h2 text-dark mb-3">WhiteEx — стабільність та методичність</h2>
          <p class="text-secondary mb-4">
            Ми створили платформу, що поєднує порядок, точність і технологічну надійність. 
            Кожен компонент WhiteEx розроблено для системного управління бізнесом.
          </p>
          <a href="about.html" class="btn btn-primary rounded-pill px-4">Дізнатись більше</a>
        </div>
        <div class="col-lg-7">
          <div class="row">
            <div class="col-sm-6 mb-4">
              <h6 class="fw-bold text-dark">Проста навігація</h6>
              <p class="small text-secondary">Інтерфейс розроблено так, щоб будь-хто міг швидко зорієнтуватися.</p>
            </div>
            <div class="col-sm-6 mb-4">
              <h6 class="fw-bold text-dark">Логічна структура</h6>
              <p class="small text-secondary">Усі модулі узгоджено взаємодіють між собою, створюючи систему без помилок.</p>
            </div>
            <div class="col-sm-6 mb-4">
              <h6 class="fw-bold text-dark">Аналітична база</h6>
              <p class="small text-secondary">WhiteEx допомагає зрозуміти тенденції та прогнозувати зміни.</p>
            </div>
            <div class="col-sm-6 mb-4">
              <h6 class="fw-bold text-dark">Підтримка клієнтів</h6>
              <p class="small text-secondary">Ми реагуємо швидко та допомагаємо налаштувати все під ваші потреби.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>`,
];
